module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contentWrapper",
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
    attrs: {
      "id": "liquidacoes"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Geração de Remessa'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v(" Liquidação Financeira")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Remessa',
        href: '#'
      }, {
        text: 'Geração de Remessa',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('p', {
    staticClass: "visible-sm visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-widget nao_imprimir"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm._.isEmpty(_vm.remessa)) ? _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Preparação de Remessas de Pagamento Eletrônico")]) : _c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Consulta e Alteração de Remessas")])]), _vm._v(" "), _c('span', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay box box-widget",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.loading.portadores) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.portadores,
      "multiple": false,
      "placeholder": "Selecione um Portador",
      "preselect-first": true,
      "label": "DesPor",
      "track-by": "DesPor",
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "portador",
      "value": _vm.DesPor,
      "disabled": !_vm._.isEmpty(_vm.remessa)
    },
    on: {
      "input": _vm.portadorSelecionado
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.CodPor === 'Cabeçalho de portador') ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaPortador"
        }, [_c('span', [_vm._v("Portador")]), _c('span', [_vm._v("Agência e Conta")])])]) : _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaPortador"
        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.CodPor))]), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(props.option.DesPor))])]), _c('span', {
          staticClass: "esmaecido"
        }, [_vm._v(_vm._s(props.option.CodPor === 'Todos' ? '' : props.option.CodAge + ' / ' + props.option.NumCco))])])])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "etiquetaPortador"
        }, [_c('span', [_c('strong', [_vm._v(_vm._s(props.option.CodPor))]), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(props.option.DesPor))])]), _c('span', {
          staticClass: "esmaecido"
        }, [_vm._v(_vm._s(props.option.CodPor === 'Todos' ? '' : props.option.CodAge + ' / ' + props.option.NumCco))])])]
      }
    }]),
    model: {
      value: (_vm.portador),
      callback: function($$v) {
        _vm.portador = $$v
      },
      expression: "portador"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), (_vm.loading.remessas) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.isEmpty(_vm.portador) || _vm.portador.CodPor === 'Todos' ? _vm.remessas : _vm._.filter(_vm.remessas, ['CodPor', _vm.portador.CodPor]),
      "multiple": false,
      "placeholder": (_vm._.isEmpty(_vm.portador) || _vm.portador.CodPor === 'Todos' ? _vm.remessas : _vm._.filter(_vm.remessas, ['CodPor', _vm.portador.CodPor])).length + ' remessa(s)',
      "label": "NumArb",
      "track-by": "NumArb",
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "numero da remessa",
      "value": _vm.NumArb
    },
    on: {
      "input": _vm.remessaSelecionada
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.CodPor === 'Cabeçalho de remessa') ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaPortador"
        }, [_c('span', [_vm._v("Portador")]), _c('span', [_vm._v("Remessa")]), _c('span', [_vm._v("Pagto.")]), _c('span', [_vm._v("Títulos")])])]) : _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "etiquetaRemessa"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(props.option.CodPor))]), _vm._v(" "), _c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(props.option.NumArb))]), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(props.option.DatPgt))]), _vm._v(" "), _c('span', {
          staticClass: "contadorRegistros",
          domProps: {
            "innerHTML": _vm._s(props.option.QtdeRegistros)
          }
        })])])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "etiquetaRemessa"
        }, [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(props.option.CodPor))]), _vm._v(" "), _c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(props.option.NumArb))]), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(props.option.DatPgt))]), _vm._v(" "), _c('span', {
          staticClass: "contadorRegistros",
          domProps: {
            "innerHTML": _vm._s(props.option.QtdeRegistros)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.remessa),
      callback: function($$v) {
        _vm.remessa = $$v
      },
      expression: "remessa"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (!_vm._.isEmpty(_vm.remessa)) ? _c('button', {
    staticClass: "btn btn-default btn-flat",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.remessa = [];
        _vm.remessaSelecionada()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [(_vm._.isEmpty(_vm.remessa)) ? _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Procura títulos em aberto para compor nova remessa</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.buscarTitulos(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar Títulos")]), _vm._v(" "), ((!_vm._.isEmpty(_vm.titulos) && _vm.filtroTituloAprovado) || (_vm.listaVazia && _vm.filtroTituloAprovado)) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Mostra títulos Não-Aprovados</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.consultaNaoAprovados()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Mostrar Não Aprovados")]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.titulos) && _vm.filtroTituloAprovado == false) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5>Limpa filtro de títulos Não-Aprovados</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limparFiltros()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Limpar Filtro")]) : _vm._e(), _vm._v(" "), (_vm.titulos.length > 0 && _vm.titulosSelecionados.length > 0 && _vm._.isEmpty(_vm.remessa) && _vm.processamentoRemessa.length === 0 && _vm._.isEmpty(_vm.tituloEditando)) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5>Cria arquivo(s) de remessa com <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) abaixo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarRemessa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" Gerar Remessas")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.remessa) && !_vm.loading.remessas) ? _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Consultar a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span> e mostra seu conteúdo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.buscarTitulos(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Consulta Remessa")]), _vm._v(" "), (_vm.titulos.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', [(_vm.titulosSelecionados.length === 0) ? _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "error",
      "size": "button--size-ss",
      "title": '<h5>Excluirá a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span></h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarRemessa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Excluir Remessa")])], 1) : _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Altera a remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span> que conterá o(s) <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) abaixo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarRemessa()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Alterar Remessa")])], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "flex"
    }
  }, [(!_vm._.isEmpty(_vm.remessa)) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Gerar PDF do relatório 130 da remessa <span class=\'realce\'>' + _vm.remessa.NumArb + '</span></h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir130(_vm.remessa.CodPor, _vm.remessa.NumArb)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Relatório 130")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.titulos.length > 0 && _vm.titulosSelecionados.length > 0) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Baixar <span class=\'realce\'>' + _vm.titulosSelecionados.length + '</span> item(ns) selecionado(s) em Excel</h5>'
    }
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.titulosSelecionados,
      "meta": _vm.excelMeta,
      "fields": _vm.processamentoRemessa.length > 0 ? _vm._.assign(_vm.excelCampos.basico, _vm.excelCampos.posProcessamento) : _vm.excelCampos.basico,
      "type": "xls",
      "name": "Títulos Selecionados.xls"
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Baixar planilha")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.titulos.length > 0) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('span', {
    staticClass: "indicadores-cb-inline",
    attrs: {
      "disabled": _vm.loading.tela
    }
  }, [(_vm.processamentoRemessa.length === 0) ? _c('div', [_c('i', {
    class: (_vm._.filter(_vm.titulos, function(t) {
      return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
    }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0 ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.selecionarTodosItens(!(_vm._.filter(_vm.titulos, function(t) {
          return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
        }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0))
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm._.filter(_vm.titulos, function(t) {
      return !_vm._.isEmpty(t.numcco) && !_vm._.isEmpty(t.tippgt)
    }).length === _vm.titulosSelecionados.length && _vm.titulos.length > 0 ? 'selecionado' : ''
  }, [_vm._v("Selecionar tudo ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [(_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', {
    staticClass: "esmaecido"
  }, [_c('span', {
    staticStyle: {
      "color": "var(--cor-azul)",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.titulosSelecionados.length))]), _vm._v(" selecionado" + _vm._s(_vm.titulosSelecionados.length > 1 ? 's' : '') + " de ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.titulos.length))]), _vm._v(" "), _c('span', {
    staticClass: "esmaecido"
  }, [_vm._v(" títulos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('span', {
    staticClass: "esmaecido"
  }, [_c('span', {
    staticStyle: {
      "color": "var(--cor-azul)",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.titulosSelecionados, function(titulo) {
    return _vm._.toNumber(titulo.vlrliq)
  }))))]), _vm._v(" do ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "esmaecido"
  }, [_vm._v("Total líquido ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm.titulos, function(titulo) {
    return _vm._.toNumber(titulo.vlrliq)
  }))))])]), _vm._v(" "), (_vm.titulosSelecionados.length > 0 && _vm.processamentoRemessa.length === 0) ? _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    staticClass: "esmaecido",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                    Previsão de "), _c('span', {
    staticStyle: {
      "color": "var(--cor-azul)",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s((_vm._.keys(_vm._.groupBy(_vm.titulosSelecionados, function(chave) {
    return chave.numcco + chave.tippgt
  }))).length))]), _vm._v("\n                    remessa(s) "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm._.values(_vm._.groupBy(_vm.titulosSelecionados, function(chave) {
    return chave.numcco + chave.tippgt
  }))), function(remessa) {
    return _c('tr', {
      attrs: {
        "role": "menuitem"
      }
    }, [_c('td', [_vm._v(_vm._s(remessa[0].numcco))]), _c('td', [_vm._v(_vm._s(remessa[0].tippgt))]), _c('td', [_vm._v(_vm._s(remessa.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(remessa, function(t) {
      return _vm._.toNumber(t.vlrliq)
    }))))])])
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 pull-right"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordenacao.por),
      expression: "ordenacao.por"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "auto",
      "float": "left"
    },
    attrs: {
      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tippgt"
    }
  }, [_vm._v("Tipo de Pagamento")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vlrliq"
    }
  }, [_vm._v("Valor Líquido")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "numtit"
    }
  }, [_vm._v("Número do Título")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "codtpt"
    }
  }, [_vm._v("Tipo do Título")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "codfpg"
    }
  }, [_vm._v("Forma de Pagamento")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "btn btn-default btn-flat",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "title": '<h5>Clique para inverter a ordenação</h5>'
    },
    on: {
      "click": function($event) {
        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
      }
    }
  }, [_c('i', {
    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
    staticStyle: {
      "font-size": "14px"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processamentoRemessa.length > 0) ? _c('span', [_vm._m(4), _vm._v(" "), _vm._l((_vm.processamentoRemessa), function(remessa) {
    return _c('span', {
      staticClass: "row"
    }, [(!_vm._.isNull(remessa.erroExecucao)) ? _c('span', [_c('div', {
      staticClass: "col-lg-12"
    }, [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(remessa.erroExecucao))])])]) : (_vm._.get(remessa, 'retorno[0].tipRet')) ? _c('span', [_c('div', {
      staticClass: "col-lg-2"
    }, [(remessa.remessa === 0) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(" Remessa não gerada")]) : _vm._e(), _vm._v(" "), (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length === 0) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(" Remessa " + _vm._s(_vm._.isEmpty(remessa) ? 'gerada' : 'alterada') + " com sucesso ")]) : _vm._e(), _vm._v(" "), (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length > 0) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(" Remessa gerada com erros")]) : _vm._e()]), _vm._v(" "), _c('span', {
      class: remessa.remessa === 0 || (remessa.remessa > 0 && (_vm._.filter(remessa.retorno, ['tipRet', 2])).length > 0) ? 'esmaecido' : ''
    }, [_c('div', {
      staticClass: "col-lg-1"
    }, [_vm._v("Portador: "), _c('b', [_vm._v(_vm._s(remessa.portador.CodPor))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1"
    }, [_vm._v("Remessa: "), _c('b', [_vm._v(_vm._s(remessa.remessa))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1"
    }, [_c('div', {
      staticClass: "contadorRegistros"
    }, [_vm._v(_vm._s(remessa.retorno.length))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7"
    }, [_vm._v("Arquivo: "), _c('b', [_vm._v(_vm._s(_vm._.isNull(remessa.arquivoGerado) ? 'nenhum' : remessa.arquivoGerado))])])])]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, _vm._l((_vm.ordenacao.por === 'vlrliq' ?
    _vm._.orderBy(_vm.titulos, [function(termo) {
      return parseFloat(termo[_vm.ordenacao.por])
    }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
    _vm._.orderBy(_vm.titulos, [_vm.ordenacao.por], [_vm.ordenacao.ordem])), function(titulo) {
    return _c('div', {
      class: 'row tarefa ' +
        (_vm._.has(titulo, 'processamento.tipRet') ? ' retornoProcessamento' + _vm._.get(titulo, 'processamento.tipRet', '') : (_vm._.find(_vm.titulosSelecionados, function(sel) {
          return sel.numtit + sel.codtpt + sel.codfor === titulo.numtit + titulo.codtpt + titulo.codfor
        }) ? 'selecionada' : ''))
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-1",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('span', {
      staticClass: "indicadores"
    }, [(!_vm._.isEmpty(titulo.numcco) && !_vm._.isEmpty(titulo.tippgt)) ? _c('span', [(_vm._.get(titulo, 'processamento.tipRet', '') === 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(titulo.processamento.remessa))]) : (_vm.processamentoRemessa.length === 0) ? _c('span', [_c('i', {
      staticClass: "nao_imprimir",
      class: (_vm._.find(_vm.titulosSelecionados, function(sel) {
        return sel.numtit + sel.codtpt + sel.codfor === titulo.numtit + titulo.codtpt + titulo.codfor
      }) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.selecionarItem(titulo)
        }
      }
    })]) : _vm._e()]) : _c('span', [_c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-exclamation-triangle",
      staticStyle: {
        "color": "var(--cor-atencao-light)"
      },
      attrs: {
        "title": '<h5>' + (_vm._.isEmpty(_vm.remessa) ? 'Não pode incluir na remessa título' : 'Nesta remessa esse título está') + ' sem conta ou sem tipo de pagamento</h5>'
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(titulo.id))]), _vm._v(" "), _c('p', {
      staticClass: "truncar",
      class: titulo.situacao === 'EM_EXECUCAO' ? 'text-green' : 'text-blue'
    }, [_vm._v(_vm._s(_vm.enumeradores[titulo.situacao]))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-10 col-sm-10 col-xs-10",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('div', {
      staticClass: "projeto truncar"
    }, [_vm._v(_vm._s(titulo.numprj) + " - " + _vm._s(titulo.nomprj))]), _vm._v(" "), _c('div', {
      staticClass: "fornecedor truncar"
    }, [_vm._v(_vm._s(titulo.codfor) + " - " + _vm._s(titulo.nomfor))])]), _vm._v(" "), _c('div', {
      staticClass: "visible-xs col-xs-2",
      staticStyle: {
        "height": "46px"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('span', [_vm._v(_vm._s(titulo.numtit))]), _vm._v(" "), (_vm._.get(titulo, 'datapr', '1900').substring(0, 4) === '1900') ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "title": '<h5>Título não aprovado</h5>'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle",
      staticStyle: {
        "color": "var(--cor-alerta-light)"
      }
    })]) : _vm._e(), _vm._v(" "), (titulo.remessaAnterior === 'SIM' && _vm._.isEmpty(_vm.remessa)) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "title": '<h5>(!)Passou por remessa anteriormente</h5>'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle",
      staticStyle: {
        "color": "var(--cor-destaque)"
      }
    })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(titulo.codtpt))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(titulo.codfor))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
      staticStyle: {
        "height": "46px",
        "display": "flex",
        "align-items": "center"
      }
    }, [(!_vm._.isEmpty(_vm.remessa)) ? _c('span', [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
      }],
      attrs: {
        "title": '<h5>' + (_vm.tiposPagamento.principais[titulo.tippgt] || _vm.tiposPagamento.outros[titulo.tippgt]) + '</h5>'
      }
    }, [_vm._v(_vm._s(titulo.tippgt))])]) : _c('span', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (titulo.tippgt),
        expression: "titulo.tippgt"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.processamentoRemessa.length > 0 || !_vm._.isEmpty(_vm.tituloEditando),
        "title": '<h5>' + (_vm.tiposPagamento.principais[titulo.tippgt] || _vm.tiposPagamento.outros[titulo.tippgt]) + '</h5>'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(titulo, "tippgt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_vm._l((_vm.tiposPagamento.principais), function(descricao, codigo) {
      return _c('option', {
        domProps: {
          "value": codigo
        }
      }, [_vm._v(_vm._s(codigo) + " - " + _vm._s(descricao))])
    }), _vm._v(" "), _c('option', {
      staticClass: "bg-gray",
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.tiposPagamento.outros), function(descricao, codigo) {
      return _c('option', {
        domProps: {
          "value": codigo
        }
      }, [_vm._v(_vm._s(codigo) + " - " + _vm._s(descricao))])
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
      staticStyle: {
        "height": "46px"
      }
    }, [(!_vm._.includes(['AMT', 'AMP', 'MIS', 'MIX'], titulo.codtpt)) ? _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
        }
      }
    }, [(_vm._.isNull(titulo.numcco)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" sem conta")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(titulo.numcco)) ? _c('span', {
      staticClass: "link_acesso",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(titulo.numcco))]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(titulo.numcco))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(titulo.usu_mci))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-5",
      staticStyle: {
        "height": "46px"
      }
    }, [(('' + titulo.codfpg) === '4' || _vm._.isNull(titulo.codfpg)) ? _c('div', {
      staticClass: "truncar"
    }, [_c('span', {
      class: _vm.processamentoRemessa.length === 0 ? 'link_acesso' : '',
      on: {
        "click": function($event) {
          _vm.processamentoRemessa.length === 0 ? _vm.editaTituloParaRemessa(titulo) : false
        }
      }
    }, [(_vm._.get(titulo, 'boleto.sucesso', false)) ? _c('span', [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" " + _vm._s(titulo.boleto.linhaDigitavel))]) : _c('span', {
      staticClass: "label label-danger"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" sem código de barras")])])]) : _c('div', [_vm._v(_vm._s(titulo.codban) + " "), _c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.codage) + " "), _c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.ccbfor))]), _vm._v(" "), _c('div', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(titulo.codfpg) + " - " + _vm._s(titulo.desfpg))])]), _vm._v(" "), _c('div', {
      staticClass: "visible-xs col-xs-2",
      staticStyle: {
        "height": "46px"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("real")(titulo.vlrori)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.vlrliq)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-1 col-sm-1 col-xs-3 text-right",
      staticStyle: {
        "height": "46px",
        "padding": "2px 0"
      }
    }, [(!_vm._.isNull(titulo.id) && _vm._.isEmpty(_vm.tituloEditando)) ? _c('span', [(titulo.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "color": "primary",
        "size": "button--size-ss",
        "title": '<h5>Assumir e Fazer</h5>'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.atribuirFazer(titulo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('g-button-ujarak', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "color": "primary",
        "size": "button--size-ss",
        "title": '<h5>Está ' + _vm.enumeradores[titulo.situacao] + '. Clique para ' + (titulo.situacao === 'EM_EXECUCAO' ? 'Reanalisar' : 'Reativar') + ' este processo e devolver para Análise ' + (!_vm._.isNull(titulo.numarb) ? '(será retirado desta remessa ' + titulo.numarb + ')' : '') + '</h5>'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.segueReanalisarOuReativar(titulo.situacao, titulo.id, titulo)
        }
      }
    }, [_c('i', {
      class: 'fa fa-' + (titulo.situacao === 'EM_EXECUCAO' ? 'undo' : 'play'),
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(_vm.tituloEditando) && (_vm.tituloEditando.numtit + _vm.tituloEditando.codtpt + _vm.tituloEditando.codfor === titulo.numtit + titulo.codtpt + titulo.codfor)) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "box-body well form-horizontal"
    }, [(('' + _vm.tituloEditando.codfpg) === '4' || _vm._.isNull(_vm.tituloEditando.codfpg)) ? _c('div', {
      staticClass: "form-group required-field",
      class: {
        'has-error': _vm.errors.first('código de barras')
      }
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Código de Barras:")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tituloEditando.boleto.numeroInformadoTela),
        expression: "tituloEditando.boleto.numeroInformadoTela"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "código de barras"
      },
      domProps: {
        "value": (_vm.tituloEditando.boleto.numeroInformadoTela)
      },
      on: {
        "keyup": _vm.validaAjustaCodigoBarras,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.tituloEditando.boleto, "numeroInformadoTela", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.first('código de barras')) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('código de barras')))]) : (_vm.tituloEditando.boleto.sucesso) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n                          " + _vm._s(_vm._.capitalize((_vm.tituloEditando.boleto.tipoCodigoInput + ' de ' + _vm.tituloEditando.boleto.tipoBoleto).replaceAll('_', ' ')) + ' correto!') + "\n                        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group required-field",
      class: {
        'has-error': _vm.errors.first('conta')
      }
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Conta:")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "options": _vm._.map(_vm._.filter(_vm.portadores, function(p) {
          return p.CodPor !== 'Todos'
        }), 'NumCco'),
        "placeholder": "Selecione uma conta",
        "selectLabel": "",
        "deselectLabel": "",
        "selectedLabel": "",
        "name": "conta"
      },
      model: {
        value: (_vm.tituloEditando.numcco),
        callback: function($$v) {
          _vm.$set(_vm.tituloEditando, "numcco", $$v)
        },
        expression: "tituloEditando.numcco"
      }
    }, [_c('template', {
      slot: "noResult"
    }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('conta')) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(_vm.errors.first('conta')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-md-10 col-md-offset-2"
    }, [_c('button', {
      staticClass: "btn btn-confirm btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.salvaEdicaoTituloParaRemessa()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-back btn-flat",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelaEdicaoTituloParaRemessa()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Cancelar")])])])])]) : _vm._e(), _vm._v(" "), (_vm._.get(titulo, 'processamento.tipRet', '') === 2) ? _c('div', {
      staticClass: "box-body"
    }, _vm._l((_vm._.get(titulo, 'processamento.detalhes', [])), function(detalhe) {
      return _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(_vm._s(detalhe.msgRet)), _c('br')])
    }), 0) : _vm._e()])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w100 imprimir"
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "direita"
  }, [_c('span', {
    staticStyle: {
      "font-size": "40px !important"
    }
  }, [_vm._v("Títulos Diversos")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Portadores...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Remessas...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('th', [_vm._v("Conta")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Títulos")]), _c('th', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75abd9c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/remessas/GeracaoRemessa.vue
// module id = 1952
// module chunks = 2